import { render, staticRenderFns } from "./CbsBpmChains.vue?vue&type=template&id=87e42402"
import script from "./CbsBpmChains.vue?vue&type=script&lang=js"
export * from "./CbsBpmChains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports